<script lang="ts">
    import {currentUnit} from "$lib/stores/unit";

    export let size = "md"

    let sizes = {
        sm: "h-7 w-7",
        md: "h-10 w-10",
        lg: "h-12 w-12",
        xl: "h-14 w-14",
        "2xl": "h-16 w-16"
    }

    let showName;
    let unit;
    currentUnit.subscribe(val => unit = val)
</script>

<div class="relative" on:mouseover={() => showName = true} on:mouseleave={() => showName = false}>
    <img class="relative flex-none {sizes[size]} rounded-full " src="/img/ci/button_recrew_solid_black.svg" alt="unit">
    <div class="{showName ? 'block' : 'hidden'} ring ring-primary-300 absolute left-2 -bottom-5 whitespace-nowrap px-2 py-0.5 bg-white rounded text-neutral-500 z-20">RECREW: {unit?.name}</div>
</div>